import { cn } from "@/lib/utils";
import { DataItem } from "../../types/common.types";
import Text from "./Text";

type DataSectionProps = {
  dataRows: DataItem<string>[][];
  className?: string;
};

const DataSection: React.FC<DataSectionProps> = ({ dataRows, className }) => {
  return (
    <section
      className={cn(
        "flex flex-col gap-2 rounded-none border-[1px] border-brand-border bg-brand-surface px-5 py-4",
        className
      )}
    >
      {dataRows.map((row, index) => (
        <DataRow key={index} data={row} />
      ))}
    </section>
  );
};

export default DataSection;

type DataRowProps = {
  data: DataItem<string>[];
};

const DataRow: React.FC<DataRowProps> = ({ data }) => {
  return (
    <div className="flex flex-wrap gap-10">
      {data.map((item) => (
        <div key={item.label}>
          <Text className="text-[14px] font-bold leading-[24.5px] tracking-[0.5px] text-shades-neutral-300">
            {item.label}
          </Text>{" "}
          <Text className="text-[14px] font-light leading-[24.5px] tracking-[0.5px] text-shades-neutral-300">
            {item.value}
          </Text>
        </div>
      ))}
    </div>
  );
};
